import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-menu"
}
const _hoisted_2 = { class: "modal-menu__content" }

import { ref } from 'vue';
import { useClickOutside } from '@/libraries/useClickOutside';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalMenu',
  props: {
    isShow: { type: Boolean }
  },
  emits: ['toggle', 'close'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const $el = ref<HTMLDivElement | null>(null);

useClickOutside($el, () => emit('close'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$el",
    ref: $el
  }, [
    _renderSlot(_ctx.$slots, "button", { buttonClass: 'modal-menu-toggle' }),
    _createVNode(_Transition, {
      name: "slide-fade",
      duration: 600
    }, {
      default: _withCtx(() => [
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "modal-menu__overlay",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "content")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}
}

})